import styled from "styled-components"
import { bp } from "../breakpoints"

export const Wrapper = styled.section`
  background-color: white;
  padding: 4rem 2rem;

  .header {
    text-align: center;
    margin-bottom: 3rem;

    h2 {
      color: ${({ theme }) => theme.colors.azul};
      font-size: 70px;
      font-weight: 300;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin: 0 0 0.5rem;

      @media ${bp.l} {
        font-size: 56px;
      }
      @media ${bp.m} {
        font-size: 35px;
      }
    }

    p {
      color: #636363;
      font-size: 23px;
      font-weight: 400;
      margin: 0 auto;

      @media ${bp.l} {
        font-size: 19px;
      }
      @media ${bp.s} {
        font-size: 16px;
      }
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }

  .card {
    border: none;
    border-bottom: 4px solid ${({ theme }) => theme.colors.amarillo};
    border-radius: 0;
    padding: 0 0 1.5rem 0;
    text-align: center;

    .card__img {
      width: 100%;
      height: auto;
      margin-bottom: 1rem;
    }

    h3 {
      color: ${({ theme }) => theme.colors.azul};
      font-size: 35px;
      font-weight: 300;
      text-transform: uppercase;
      letter-spacing: 0.03em;

      @media ${bp.l} {
        font-size: 30px;
      }
      @media ${bp.m} {
        font-size: 25px;
      }
      margin: 0;
      padding-bottom: 0.8rem;
      border-bottom: 1px solid ${({ theme }) => theme.colors.azul};
      margin-bottom: 1rem;
    }

    .card__specs {
      display: flex;
      justify-content: space-around;
      gap: 0.5rem;

      @media ${bp.m} {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
      }
    }

    .spec {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0;

      img {
        width: 48px;
        height: 48px;
        margin-bottom: 5px;
      }

      span {
        font-size: 15px;
        color: #363636;
        font-weight: 400;
        text-align: center;
        line-height: 1.3;
      }
    }
  }

  @media ${bp.m} {
    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .card:last-child {
      grid-column: 1 / -1;
      max-width: calc(50% - 1rem);
      margin: 0 auto;
      width: 100%;
    }
  }
  @media ${bp.s} {
    .grid {
      grid-template-columns: 1fr;
    }
    .card:last-child {
      max-width: 100%;
    }
  }
`
